import { WajeezTabsContainer } from '@wajeez-web/components/layouts';
import BusinessQuantity from '../components/BusinessQuantity';
import { useEffectCancelled } from '@wajeez-web/components/helpers';

import {
  BusinessActions,
  CreateBusinessGroupMultilingual,
  useBusinessSelector,
} from '@wajeez-web/stores/business-group';
import { useParams, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '@wajeez-web/stores/base';
import { useTranslation } from 'react-i18next';
import BusinessBasicInfo from '../components/BusinessBasicInfo';
import { Identity } from '@wajeez-web/core/api-base';
import BusinessSubsicription from '../components/BusinessSubsicription';
import BusinessUsers from '../components/BusinessUsers';
import BusinessReports from '../components/BusinessReports';
const CreateBusinessGroup = () => {
  const { id } = useParams<{ id: string }>();
  const { details } = useBusinessSelector((state) => state.businessGroups);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { t } = useTranslation();
  useEffectCancelled(
    (canceller: AbortController) => {
      if (id) {
        dispatch(
          BusinessActions.getBusinessByIdMultilingualAsync(parseInt(id))
        );
      }

      return () => {
        canceller.abort();

        dispatch(BusinessActions.clearDetailsMultilingual());
      };
    },
    [id]
  );

  const submitbusiness = async (data: CreateBusinessGroupMultilingual) => {
    const res = id
      ? await dispatch(
          BusinessActions.editBusinessMultilingualAsync({
            ...data,
            id: parseInt(id),
          })
        )
      : await dispatch(BusinessActions.createBusinessMultilingualAsync(data));
    if (res.meta.requestStatus === 'fulfilled') {
      // TODO: Redo this
      navigate('/business-group/' + res.payload + '/0');
    }
  };

  return (
    <div>
      <div>
        <WajeezTabsContainer
          title={
            id
              ? `${t(`general.${'Edit'}`, '')} ${t(
                  `general.${'Business Group'}`,
                  ''
                )}${details?.name ? `"${details?.name}"` : ''} `
              : `${t(`general.${'Business Group'}`, '')}`
          }
          tabs={[
            {
              text: t(`general.${'Basic Info'}`, ''),
              disabled: false,
              content: () => <BusinessBasicInfo onSubmit={submitbusiness} />,
            },
            {
              text: t(`general.${'Business Quantity'}`, ''),
              disabled: id ? false : true,

              content: () => (
                <BusinessQuantity
                  id={Number(id)}
                  title={t(`general.${'Business Quantity'}`, '')}
                />
              ),
            },
            {
              text: t(`general.${'Business Subscription'}`, ''),
              disabled: id ? false : true,
              content: () => (
                <BusinessSubsicription
                  id={Number(id)}
                  title={t(`general.${'Business Subscription'}`, '')}
                />
              ),
            },
            {
              text: t(`general.${'Business Users'}`, ''),
              disabled: id ? false : true,
              content: () => (
                <BusinessUsers
                  id={Number(id)}
                  title={t(`general.${'Business Users'}`, '')}
                />
              ),
            },
            {
              text: t(`general.${'Business Reports'}`, ''),
              disabled: id ? false : true,
              content: () => (
                <BusinessReports
                  id={Number(id)}
                  title={t(`general.${'Business Reports'}`, '')}
                />
              ),
            },
          ]}
        />
      </div>
    </div>
  );
};

export default CreateBusinessGroup;
